{
  "Banking & Insurance": "Bank och försäkring",
  "Business Development": "Affärsutveckling",
  "Computer Science": "Datavetenskap",
  "Data Management": "Datahantering",
  "Design": "Design",
  "Digital Awareness": "Digital medvetenhet",
  "Engineering": "Ingenjörsvetenskap",
  "Finance & Accounting": "Ekonomi och redovisning",
  "IT Services": "IT-tjänster",
  "Languages": "Språk",
  "Leadership": "Ledarskap",
  "Legal & Tax": "Juridik och skatt",
  "Marketing & Communication": "Marknadsföring och kommunikation",
  "Operational Excellence": "Verksamhetsoptimering",
  "Other": "Diverse",
  "People & Culture": "Människor och kultur",
  "Personal Development": "Personlig utveckling",
  "Security & Risk": "Säkerhet och risk",
  "Service, Sales & Advisory": "Service, försäljning och rådgivning",
  "Sustainability": "Hållbarhet",
  "You & Your Employer": "Du och din arbetsgivare"
}
